export const VERSION = {
  PROD: 'V. 3.3.2',
  QA: 'V. 5.3.0 (QA)',
}
